import { Menu } from "lucide-react";
import { useAuth } from "@/auth/useAuth";

interface Props {
  onMenuClick?: () => void;
}

export function Header({ onMenuClick }: Props) {
  const { user } = useAuth();

  return (
    <header className="md:hidden flex items-center justify-between px-4 py-3 border-b border-gray-100 bg-white">
      <button
        type="button"
        onClick={onMenuClick}
        data-tour="header-menu"
        className="p-1.5 rounded-md hover:bg-gray-100 transition-colors text-gray-500"
        aria-label="Apri menu"
      >
        <Menu size={20} />
      </button>
      <span className="text-sm text-gray-400">{user?.name || user?.email}</span>
    </header>
  );
}
